module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7YPScy/tc-custom/9781449442705.jpg?1707968559606",
      "alt": "This image is the cover for the book Close to Home: Uncut, Close to Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Close to Home: Uncut, Close to Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Only in the world of "), _c('i', [_vm._v("Close to Home")]), _vm._v(" can you find hospitals staffed with hypochondriac-sniffing dogs, Yellowstone employees who secretly spike Old Faithful with gallons of Mr. Bubble, and telephones equipped with Caller I.Q. Of course, for the creator of the screamingly successful "), _c('i', [_vm._v("Close to Home")]), _vm._v(", it's just another no-holds-barred day at the drawing board.")]), _c('p', [_vm._v("Specializing in humor in everyday situations, John McPherson lampoons the worlds of parenting, marriage, school, health care, work, and leisure in ways that get readers to laugh at themselves.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John McPherson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0